/**
 * @author  Mario Lorenz, www.buchsuite.de
 * @license https://www.gnu.org/licenses/gpl-2.0.html GNU General Public License, version 2 (one or other)
 */

import { tns } from 'tiny-slider';

/**
 * Arrow glyphs for the slider controls. Inline SVG instead of an icon font: the
 * "icon icon-angle-*" classes come from the buchsuite iconset, which twigdevelop loads
 * but apexdevelop does not - there the buttons stayed empty. currentColor follows the
 * button color. Paths: Bootstrap Icons chevron-left/-right (MIT).
 */
const ARROW_PREV = '<svg viewBox="0 0 16 16" width="28" height="28" fill="currentColor" aria-hidden="true">'
    + '<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg>';
const ARROW_NEXT = '<svg viewBox="0 0 16 16" width="28" height="28" fill="currentColor" aria-hidden="true">'
    + '<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>';

/**
 * Initialize all sliders on the page
 */
export function initSliders() {
    // Containers tns already turned into a slider (class "tns-slider") are skipped: the
    // twigdevelop theme initializes the same classes with its own bundle, and a second
    // tns() on one container stacks a second nav and control set onto it.
    // Article-Lists with carousel
    document.querySelectorAll('.tiny-slider-articlelist:not(.tns-slider)').forEach(function (element) {
        tns({
            container: element,
            gutter: 30,
            rewind: true,
            items: 1,
            navPosition: "bottom",
            mouseDrag: true,
            controlsText: [ARROW_PREV, ARROW_NEXT],
            responsive: {
                576: {
                    items: 2,
                    nav: true,
                    controls: false
                },
                992: {
                    items: 3,
                    nav: false,
                    controls: true
                },
                1140: {
                    items: 4,
                    nav: false,
                    controls: true
                }
            }
        });
    });

    // MorePics with carousel
    document.querySelectorAll('.tiny-slider-morepics:not(.tns-slider)').forEach(function (element) {
        tns({
            container: element,
            gutter: 10,
            items: 1,
            mouseDrag: true,
            nav: true,
            controls: false,
            navPosition: "bottom",
            responsive: {
                576: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1140: {
                    items: 4
                }
            }
        });
    });

    // Startpage: Headerslider
    function customizedHeaderSlider(info, eventName) {
        const current = info.index;
        const container = info.container;
        const tnsItems = container.querySelectorAll(".tns-item");
        const currentItem = tnsItems[current]?.querySelector(".pageheader-slider-item");

        if (!currentItem) return;

        const tnsBGElementName = currentItem.getAttribute("data-bg-element");
        const tnsBGColor = currentItem.getAttribute("data-bg-color");

        let tnsBGElement = currentItem;

        if (typeof tnsBGElementName !== "undefined" && tnsBGElementName) {
            tnsBGElement = container.closest("." + tnsBGElementName);
        }

        if (typeof tnsBGColor !== "undefined" && tnsBGColor) {
            tnsBGElement.style.backgroundColor = "#" + tnsBGColor;
        } else {
            tnsBGElement.removeAttribute("style");
        }
    }

    document.querySelectorAll('.tiny-slider-pageheader:not(.tns-slider)').forEach(function (element) {
        const slider = tns({
            container: element,
            items: 1,
            autoplay: true,
            autoplayTimeout: 10000,
            autoplayButtonOutput: false,
            nav: true,
            controls: false,
            mouseDrag: true,
            navPosition: "bottom"
        });

        slider.events.on('indexChanged', customizedHeaderSlider);
    });
}
